import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import styles from "./RatesTable.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import uuid4 from "uuid4";
import { api } from "../../../api/api";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";

const customStyles = {
  headRow: {
    style: {
      border: "none",
    },
  },
  headCells: {
    style: {
      color: "white",
      backgroundColor: "#6f9be2",
      fontWeight: 600,
      fontSize: "16px",
    },
  },
  rows: {
    style: {
      borderBottomColor: "#FFFFFF",
    },
    highlightOnHoverStyle: {
      backgroundColor: "#bfcfea",
      borderBottomColor: "#FFFFFF",
    },
  },
};

function RatesTable(props) {
  const inputStyles = {
    width: "100%",
    border: "none",
    outline: "none",
    padding: "5px",
    borderRadius: "3px",
    boxShadow: "1px 2px 3px rgb(186, 186, 186)",
  };
  const [boxes, setBoxes] = useState([]);
  useEffect(() => {
    const getBoxesData = async () => {
      try {
        try {
          const fetchedBoxes = await api.get("/boxes/getBoxes");
          setBoxes(fetchedBoxes.data.boxes);
        } catch (err) {}
      } catch (err) {}
    };
    getBoxesData();
  }, []);
  const pId = uuid4();
  const [rows, setRows] = useState([]);

  const [formData, setData] = useState([]);

  const [dataUpdated, setDataUpdated] = useState({
    id: null,
    field: null,
    value: null,
  });
  const [rowManipulator, setRowManipulator] = useState({
    boxId: null,
    dataId: null,
    isCustom: false,
  });
  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      allowOverflow: true,
      style: {
        color: "#202124",
        fontSize: "14px",
        fontWeight: 500,
      },
    },
    {
      name: "Weight",
      selector: (row) => row.weight,
      allowOverflow: true,
    },
    {
      name: "Length",
      selector: (row) => row.length,
      allowOverflow: true,
    },
    {
      name: "Width",
      selector: (row) => row.width,
      allowOverflow: true,
    },
    {
      name: "Height",
      selector: (row) => row.height,
      allowOverflow: true,
    },
    {
      cell: (row) => (
        <button
          onClick={() => {
            deleteRowHandler(row.id);
          }}
          style={{
            border: "none",
            outline: "none",
            cursor: "pointer",
            background: "transparent",
          }}
        >
          <FontAwesomeIcon size="2x" color="red" icon={faXmark} />
        </button>
      ),
      width: "56px",
    },
  ];

  useEffect(() => {
    if (rowManipulator.boxId && !rowManipulator.isCustom) {
      const desiredBox = boxes.find((box) => box._id === rowManipulator.boxId);
      const desiredFormRow = rows.find(
        (row) => row.id === rowManipulator.dataId
      );
      const desiredDataRow = formData.find(
        (row) => row.id === rowManipulator.dataId
      );

      if (desiredBox && desiredFormRow) {
        desiredFormRow.name = (
          <select
            onChange={(e) => selectChangeHandler(desiredFormRow.id, e)}
            style={inputStyles}
            id="name"
            name="name"
            type="text"
            defaultValue={desiredBox.name}
            placeholder="Name"
          >
            <option value="custom">Custom</option>
            {boxes.map((box) => {
              return (
                <option key={box._id} value={box._id}>
                  {box.name}
                </option>
              );
            })}
          </select>
        );
        desiredFormRow.weight = (
          <input
            onChange={(e) => inputChangeHandler(desiredFormRow.id, e)}
            placeholder="Weight"
            style={inputStyles}
            type="text"
            id="weight"
            name="weight"
            min="0"
            defaultValue={desiredBox.weight}
          ></input>
        );
        desiredFormRow.length = (
          <input
            onChange={(e) => inputChangeHandler(desiredFormRow.id, e)}
            placeholder="Length"
            style={inputStyles}
            type="text"
            id="length"
            name="length"
            min="0"
            defaultValue={desiredBox.length}
          ></input>
        );

        desiredFormRow.width = (
          <input
            onChange={(e) => inputChangeHandler(desiredFormRow.id, e)}
            placeholder="Width"
            style={inputStyles}
            type="text"
            id="width"
            name="width"
            min="0"
            defaultValue={desiredBox.width}
          ></input>
        );
        desiredFormRow.height = (
          <input
            onChange={(e) => inputChangeHandler(desiredFormRow.id, e)}
            placeholder="Height"
            style={inputStyles}
            type="text"
            id="height"
            name="height"
            min="0"
            defaultValue={desiredBox.height}
          ></input>
        );
        desiredDataRow.name = desiredBox.name;
        desiredDataRow.weight = desiredBox.weight;
        desiredDataRow.length = desiredBox.length;
        desiredDataRow.width = desiredBox.width;
        desiredDataRow.height = desiredBox.height;

        // Make a copy of rows state and update the specific row
        const updatedRows = [...rows];
        const updatedData = [...formData];
        const rowIndex = updatedRows.findIndex(
          (row) => row.id === desiredFormRow.id
        );
        updatedRows[rowIndex] = desiredFormRow;
        const dataIndex = updatedData.findIndex(
          (row) => row.id === desiredDataRow.id
        );
        updatedRows[rowIndex] = desiredFormRow;
        updatedData[dataIndex] = desiredDataRow;

        // Update the state of rows with the updatedRows array
        setRows(updatedRows);
        setData(updatedData);
      }
    }
    //eslint-disable-next-line
  }, [rowManipulator]);

  useEffect(() => {
    if (dataUpdated.id) {
      const rowIndex = formData.findIndex((i) => i.id === dataUpdated.id);
      const field = dataUpdated.field;
      const value = dataUpdated.value;
      setDataUpdated({ id: null, field: null, value: null });
      const dat = formData;
      setData(dat.filter((i) => i.id !== dataUpdated.id));
      const chosen = dat[rowIndex];
      const newEntry = { ...chosen, [field]: value };
      setData((prev) => [...prev, newEntry]);
    }
    //eslint-disable-next-line
  }, [dataUpdated, rows]);

  const inputChangeHandler = (idRow, e) => {
    const { id, value } = e.target;
    if (
      id === "weight" ||
      id === "height" ||
      id === "width" ||
      id === "length"
    ) {
      if (value <= 0 && value.length > 0) {
        toast.error("Value Can Not Be Less Than 1");
        return;
      }
    }
    setDataUpdated({ id: idRow, field: id, value: value });
  };

  const selectChangeHandler = (id, e) => {
    const { value } = e.target;
    if (value === "custom") {
    } else {
      setRowManipulator({
        boxId: value,
        dataId: id,
        isCustom: false,
      });
    }
  };

  const addNewRowHandler = () => {
    const newId = uuid4();
    const newRecord = {
      id: newId,
      name: (
        <select
          // onChange={(e) => inputChangeHandler(newId, e)}
          onChange={(e) => selectChangeHandler(newId, e)}
          style={inputStyles}
          id="name"
          name="name"
          type="text"
          placeholder="Name"
        >
          <option value="custom">Custom</option>
          {boxes.map((box) => {
            return (
              <option key={box._id} value={box._id}>
                {box.name}
              </option>
            );
          })}
        </select>
      ),
      weight: (
        <input
          onChange={(e) => inputChangeHandler(newId, e)}
          placeholder="Weight"
          style={inputStyles}
          type="text"
          id="weight"
          name="weight"
          min="0"
        ></input>
      ),
      length: (
        <input
          onChange={(e) => inputChangeHandler(newId, e)}
          placeholder="Length"
          style={inputStyles}
          type="text"
          id="length"
          name="length"
          min="0"
        ></input>
      ),
      width: (
        <input
          onChange={(e) => inputChangeHandler(newId, e)}
          placeholder="Width"
          style={inputStyles}
          type="text"
          id="width"
          name="width"
          min="0"
        ></input>
      ),
      height: (
        <input
          onChange={(e) => inputChangeHandler(newId, e)}
          placeholder="Height"
          style={inputStyles}
          type="text"
          id="height"
          name="height"
          min="0"
        ></input>
      ),
    };
    const newDataRecord = {
      id: newId,
      name: "",
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
    };
    setData((prev) => [...prev, newDataRecord]);
    setRows((prev) => [...prev, newRecord]);
  };

  useEffect(() => {
    if (boxes.length > 0) {
      addNewRowHandler();
    }
  }, [boxes]);

  const resetHandler = () => {
    setRows([]);
    setData([]);
  };

  const deleteRowHandler = (id) => {
    const r = rows;
    const d = formData;
    const newR = r.filter((prev) => prev.id !== id);
    const newD = d.filter((prev) => prev.id !== id);
    setRows(newR);
    setData(newD);
  };
  const calculateHandler = () => {
    let totalWeight = 0;
    let totalLength = 0;
    let totalWidth = 0;
    let totalHeight = 0;

    formData.forEach((item) => {
      totalWeight += item.weight;
      totalLength += item.length;
      totalWidth += item.width;
      totalHeight += item.height;
    });
    props.onSubmit(
      {
        weight: totalWeight,
        height: totalHeight,
        length: totalLength,
        width: totalWidth,
      },
      formData
    );
  };
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h2>Package Details</h2>
      </div>
      <div className={styles.tableControls}>
        <button onClick={addNewRowHandler}>Add New Box</button>
        <button disabled={props.isLoading} onClick={calculateHandler}>
          {" "}
          <ClipLoader loading={props.isLoading} color="#ffffff" size={10} />
          {!props.isLoading && "Calculate"}
        </button>
        <button onClick={resetHandler}>Reset</button>
        <div className={styles.info}>
          <p>Weight: EACH | KG | CM</p>
        </div>
      </div>
      <div
        style={{
          boxShadow: "1px 2px 3px rgb(186, 186, 186)",
          borderRadius: "10px",
        }}
      >
        <DataTable
          className={styles.table}
          columns={columns}
          data={rows}
          customStyles={customStyles}
          highlightOnHover
        />
      </div>
    </div>
  );
}

export default RatesTable;
